import React from "react";
import TurnrInput from "~/components/input/TurnrInput.jsx";
import TurnrDropdownSelect from "~/components/input/TurnrDropdownSelect.jsx";
import { InputGridWrapper, SettingsContainerWrapper } from "./settingComponents";

export default function GeneralDesignSettings(props) {
    const { iFrameData } = props;
    return (
        <SettingsContainerWrapper>
            <InputGridWrapper>
                <TurnrInput
                    size={"small"}
                    tooltip="The color that will be used for the app. Note that for light colors some texts become black to help with the contrast against a white background"
                    label={"Color: " + props.colorPrimary.value}
                    type="color"
                    fullWidth={true}
                    {...props.colorPrimary}
                    onChange={props.setColorPrimary}
                    required
                />
            </InputGridWrapper>
            <InputGridWrapper>
                <TurnrDropdownSelect
                    size={"small"}
                    label="Card edges"
                    tooltip="Change roundness of various containers and cards"
                    fullWidth={true}
                    {...props.overallType}
                    onChange={props.setOverallType}
                    options={iFrameData?.overallTypeOptions || []}
                />
            </InputGridWrapper>

            {/*<InputGridWrapper>*/}
            {/*    <TurnrCheckbox*/}
            {/*        size={"small"}*/}
            {/*        label="Card edges"*/}
            {/*        tooltip="Change roundness of various containers and cards"*/}
            {/*        fullWidth={true}*/}
            {/*        {...props.overallType}*/}
            {/*        onChange={props.setOverallType}*/}
            {/*        options={iFrameData?.overallTypeOptions || []}*/}
            {/*    />*/}
            {/*</InputGridWrapper>*/}
        </SettingsContainerWrapper>
    );
}
